import { createContext } from 'react';

import Ledger from '../types/Ledger';

type LedgerContextType = Partial<
  Pick<Ledger, 'additionalCharges' | 'discount'>
>;
export const LedgerContext = createContext<LedgerContextType>({});
